import { useCallback, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import pMap from 'p-map';
import { Table } from '../../components/table/Table';
import * as service from '../../services/jobs-service';
import { useAlerts } from '../../hooks/use-alerts';
import { Dialog } from '../../components/Dialog';
import { QueueJob } from './QueueJob';

export function QueueJobs(props) {
  const { queue, type, onCancel } = props;
  const [jobs, setJobs] = useState();
  const [selected, setSelected] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const { showError } = useAlerts();

  const processSelected = useCallback(
    async (action, ids) => {
      await pMap(
        ids,
        (id) =>
          action(queue, id).then(() => {
            setJobs((current) => current.filter((job) => job.id !== id));
          }),
        { concurrency: 5 },
      ).catch(showError);
    },
    [queue, showError],
  );

  useEffect(() => {
    service.getJobs(queue, type).then(setJobs);
  }, [queue, type]);

  return (
    <>
      <Dialog
        actions={false}
        title={`${queue} ${type} jobs`}
        onCancel={onCancel}
        width="lg"
      >
        <Table
          sx={{ minHeight: 200 }}
          rows={jobs || []}
          loading={!jobs}
          columns={buildColumns()}
          initialState={{ sorting: { sortModel: [{ field: 'timestamp' }] } }}
          hideFooter={false}
          checkboxSelection={true}
          rowSelectionModel={selected}
          onRowSelectionModelChange={setSelected}
          actions={[
            <Button
              key="remove"
              disabled={!selected.length}
              onClick={() => processSelected(service.removeJob, selected)}
            >
              Remove
            </Button>,
            type === 'failed' ? (
              <Button
                key="redrive"
                disabled={!selected.length}
                onClick={() => processSelected(service.redriveJob, selected)}
              >
                Redrive
              </Button>
            ) : null,
          ]}
        />
      </Dialog>
      {selectedJobId && (
        <QueueJob
          queue={queue}
          type={type}
          jobId={selectedJobId}
          onClose={() => setSelectedJobId(null)}
        />
      )}
    </>
  );

  function buildColumns() {
    return [
      {
        field: 'timestamp',
        headerName: 'Time',
        flex: 0.5,
        type: 'date',
        valueGetter: ({ value }) => value && new Date(value),
        renderCell: ({ value, row }) => (
          <Button
            color="inherit"
            sx={{
              justifyContent: 'flex-start',
              padding: 0,
              textDecoration: 'underline',
            }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedJobId(row.id);
            }}
          >
            {new Date(value).toLocaleString()}
          </Button>
        ),
      },
      {
        field: 'name',
        headerName: 'Name',
        flex: 0.5,
      },
      {
        field: 'data',
        headerName: 'Data',
        flex: 1,
        valueFormatter: ({ value }) => JSON.stringify(value),
      },
      {
        field: 'failedReason',
        headerName: 'Failure',
        flex: 1,
      },
    ];
  }
}
